 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		94: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"components-product_post-product_post~layouts~post-content-sidebar","6":"header~layouts~post-content-body","7":"giftguide","8":"legacyIbdPage","10":"ad-AdContainer","11":"components-analytics-analytics","12":"container","13":"fc_executive_board","14":"fc_link-fc_link","15":"Mcp2018Page","16":"aboutUsWpPage","17":"author","18":"category_page","19":"companyIndexSectionPage","20":"companyPage","21":"components-all_feed-all_feed","22":"components-feature_feed-feature_feed","23":"components-feature_term-feature_term","24":"components-franchise_showcase-franchise_showcase","25":"components-megatron-megatron","26":"components-more-stories-component-more-stories-component","27":"components-not_found_component-not_found_component","28":"components-slug-slug","29":"components-video_module-video_module","30":"customCollectionPage","31":"giftpage","32":"legacyMcpPage","33":"loginPage","34":"logoutPage","35":"magazineTagPage","36":"magazine_page","37":"mcp2019Page","38":"myAccountPage","39":"news_page","40":"newsletters_page_marketo","41":"notFoundPage","42":"offerPage","43":"personPage","44":"playlistIndexPage","45":"playlistPage","46":"podcastPage","47":"post_page","48":"productIndex","49":"productPage","50":"registerPage","51":"resetPasswordPage","52":"sitemapIndex","53":"sitemapPost","54":"subscribePage","55":"tagPage","56":"videoIndex","57":"videoPage","58":"views-containers-layouts-blank_layout-blank_layout","59":"views-containers-layouts-web_layout-web_layout","89":"MarketoNewsletterForm","90":"MicCarousel","91":"MicIcon","92":"MicMobileIconCarousel","93":"Success-SubmissionSuccess","95":"applications-most-innovative-companies","96":"brands_that_matter_list_page","97":"brands_that_matter_page","98":"categoryLink","99":"components-BackgroundHighlight-BackgroundHighlight","100":"components-MultiTabList-MultiTabList","101":"components-QuickCarousel-QuickCarousel","102":"components-StickyBar-StickyBar","103":"components-categories","104":"components-config-config","105":"components-dianomi-dianomi_script","106":"components-editor_highlights-editor_highlights","107":"components-finite_scroll","108":"components-footer-footer","109":"components-franchise_accordion_section-franchise_accordion_section","110":"components-franchise_intro-franchise_intro","111":"components-ibd_category-ibd_category","112":"components-image-image","113":"components-magazine_archive-magazine_archive","114":"components-masthead-masthead","115":"components-mcp_section-mcp_section","116":"components-mic_mobile_menu-mic_mobile_menu","117":"components-newsletters-recaptcha","118":"components-notice","119":"components-person_company_component-person_company_component","120":"components-piano-pianoBottomBanner","121":"components-podcast_tile-podcast_tile","122":"components-podcast_tile-podcast_tile_featured","123":"components-post-content-insert","124":"components-product_post-product_post","125":"components-ranked","126":"components-recirc-recirc","127":"components-related_posts-related_posts","128":"components-related_slider-related_slider","129":"components-sectors_list-sectors_list","130":"components-social","131":"components-social-social","132":"components-top_50-top_50","133":"components-top_50_shuffle-top_50_shuffle","134":"components-video_megatron-video_megatron","135":"components-video_module-utils-video_module_ads","136":"containers-pages-list_landers-bwi-2020","137":"containers-pages-list_landers-ibd-2020","138":"containers-pages-list_landers-mic-2021","139":"content-innovation_festival_banner","140":"fc-components-main-components","141":"fc-components-main-components-StickyBar-StickyBar","142":"fc-components-main-containers","143":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","144":"fc-components-main-containers-IbdLayout-IbdLayout","145":"fc-components-main-containers-WciLayout-WciLayout","146":"franchises-BtmApplyPage","147":"franchises-BwiApplyPage","148":"franchises-IbdApplyPage","149":"franchises-MicApplyPage","150":"franchises-NbttApplyPage","151":"franchises-WciApplyPage","152":"header","153":"innovation_by_design_future_page","154":"innovation_by_design_page_franchise","155":"layouts","156":"layouts-mcp","157":"nav_main_menu-nav_main_menu","158":"package_article_list_entry","159":"packages-nav-package_sticky_nav","160":"post-content-body","161":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"cb800b0af57b85a79bd7","2":"5fc88fe3c045a7d947b5","3":"b0aebfcb84b47572b3fe","4":"ae8e548d15cdb452c5bd","5":"262af1c4247d87f19b86","6":"5fa55fa6e275b0f0ad41","7":"dc3a709b45dce1c599c1","8":"15cc0c793f26aa2238ac","9":"be3fdbdd81ffefc39a91","10":"520e41907a34c80f244c","11":"4d833f16d74f21dc1f2c","12":"11ec1880e993b493ffd3","13":"7ccffb1ea0e3b4b5bd65","14":"bd40f4b788d53c87c2e0","15":"f0fbf0c4e81029ec23ac","16":"c8abdc97e65aa511afe2","17":"3349f6c620f6f3c705e8","18":"63803225d2247068fe52","19":"4d3d1983923aca60fb87","20":"db66720fd78bb3aa4276","21":"626557ec3278bcae2fad","22":"b9fcd3590c13b3f1c57f","23":"7fbdb0e151a2e7cd0d1f","24":"cede3d864f84fcfb24b4","25":"0bffbc7926e6c621a24a","26":"d1d6f6af3e7431b85fef","27":"4e17f98ef1a58f450108","28":"df9466e478d7353d2452","29":"37eecca4a34409a50833","30":"1628e24cda3a6c7b1adf","31":"1fc0abadb07f8b2f79a9","32":"05ea9f1f7839d0fa3a77","33":"164304ea6c0e204fc329","34":"8c8fd7b583a3d3840bb4","35":"3deba73d1b6a9e8e5343","36":"668104a59b352a7dd895","37":"7742b0ba9261d055e143","38":"77c9cada816d560b18e8","39":"01e19770e94fb4c071d7","40":"90b04c0c43bd8790945d","41":"96efcc5e09b854408944","42":"e8748b9b9542fdb62e8b","43":"6495bd9dde354cf52455","44":"327e47d4ed1f7bcb0f29","45":"4db29da94748ee393fc3","46":"6412948d352316224968","47":"7e0d0bf1b687146d56fe","48":"33a8b2bce0f6dec95bdb","49":"35107ce6345415285ed3","50":"56d496c975feb793f776","51":"3c3dc19ceba5186dba70","52":"2f9ae771e19eb113263e","53":"38228d3f8a7d658a8fac","54":"0764716f3cb22c93f6aa","55":"93fd80d978688a41a01d","56":"d6c8729140aaa3e9c385","57":"4af0c1a59456d549ca84","58":"661a3d6fc1b9e75864e6","59":"0eb4f60b96565cb3bb7c","60":"ed6aebef412c804e4830","61":"093b4521e56c54344c4c","62":"8b84b42eeb3feeefbbac","63":"b996a9ca576536e4e873","64":"0846bba5fd1531b8a980","65":"9b4cf0a5c637d3bd1fba","66":"f04434c7d2f4a68003df","67":"800d39c7b912798d9284","68":"b9d6b6e0cc49f17cedf4","69":"e242c478c4a289b061ad","70":"b853a27b736f7ccdb466","71":"f2832d301e461db46331","72":"fcb673f21216ce3096f8","73":"e2517558575bbed4a340","74":"5e286101b08597a401ce","75":"b772897aa9299f7f884d","76":"99e7e853a8e8dd8366f7","77":"73e882a3fcbcfab4c680","78":"5731357ce4b6267f8cd4","79":"66920b67c805e2b61298","80":"45b3fdf859fe307ba0be","81":"f6cc0a8338a248bf404c","82":"f0fbf70883f0aeebedec","83":"e3f43096ca78c3d27761","84":"51b2aa1889b298f52740","85":"6e04ed3ca061f4538a01","86":"d1fc60c8e57ad4b92f6a","87":"8f78d05dd1509ba9af82","88":"7fb735d9bc4cf7eefe90","89":"58c9982c5ad902b7219b","90":"77882301d3a9e96c1428","91":"42c77be1db5e50699447","92":"0d06f1ac3a0ac234c148","93":"e2a362e9ea406f3a1013","95":"05f9e5aba86fca3bf7bb","96":"156842bdb603069d4b76","97":"235fec87703b8eaec5bb","98":"1eed6c4a62e7fec23f26","99":"d4397d6cde35ce75dc11","100":"2bad53897c8ba8361460","101":"b8e50101bdaaba657c1d","102":"c56ca44a15bd0128fee8","103":"34870a4ce0a74c24455a","104":"e7d25eb9704609a6c028","105":"0488337063ec0a1d92d3","106":"07b34743f7719964339c","107":"77564f9dd08291720a97","108":"d8963afd6b7b5b0706ba","109":"2db5f8ef4169fa15043c","110":"4ad318f1c40892cd2394","111":"49d8a756125056bf509d","112":"4b35ae63e44e6460fc7e","113":"7988f74624fe99d1e588","114":"db3ecdb0dc62f0b0ccff","115":"beb5d6fbebb7a9f67d9e","116":"83408f0d60916fbb04bf","117":"bdd3843cd5f9696abee7","118":"4a9326ba75836bf3a731","119":"b7013088a9276dc2b0ef","120":"4e343bf5f6ebc1a68f71","121":"c9702fb4b43245c52b9e","122":"9b66674a61f3d0856db9","123":"18d4d8b692149d314400","124":"3ba10a26711f2df8404f","125":"719c8bf5681cbc0d0141","126":"df5843701576213a9e71","127":"15486238758831d97909","128":"8bc294d1ae6972a2bffb","129":"2d1961bd01811289754c","130":"3116a952bbb074136c9c","131":"4f89019d20b623b47624","132":"0aaf8b348f461c8e7397","133":"d36669e8244d4c87c908","134":"a84cb7c4bcc35da5e842","135":"1e14f58ec468bf4199f7","136":"612f56d6fb0a8335a6c6","137":"c27dc1f535b990e97ed7","138":"8d1db0d326c0fd292029","139":"58696036535a47380b66","140":"4b382b604bd8f0718ef5","141":"587a6de5fa6d8e79587a","142":"4a3908fcf89453bc9110","143":"e6613588b8d9b055da84","144":"3dee992107fe573e9620","145":"edb812a79336032f97c5","146":"da2a2a5f9f5c387c2f84","147":"cc558816a9420eea3e46","148":"376fe86d8625a9a11f42","149":"e2432dfdbd449b127c6d","150":"f7713f3f200e78a6a3ad","151":"e1e5b3b0e150ab044db1","152":"fb85aa0a2681f65cd61b","153":"edb8e34ff61a9797da4f","154":"42be406fa127ebaad570","155":"a129e55a2253bab23310","156":"49c44824da1f84fba2c7","157":"128c1f609be9526d12ab","158":"0dcc9e61241d671d9978","159":"4c97d042cb10a5aeb2cf","160":"345773e85c15e7a5fa19","161":"b6a195ba65f4ada31907"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([760,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
